import React, { useState, useEffect } from "react";
import SecurityLogo from "../../assets/png/security-info.png";
import CommonModal from "../Modals/CommonModal";

const ActivateAccDrawer = ({ lockUnlock, accountId, status }) => {
  const [modalShow, setModalShow] = useState(false);
  useEffect(() => {
    if (modalShow) {
      setTimeout(function () {
        setModalShow(false);
        document.getElementById("closeDrawer").click();
      }, 2000);
    }
  }, [modalShow]);
  const confirmLock = () => {
    lockUnlock(status, accountId);
    document.getElementById("closeDrawer").click();
    setModalShow(true);
  };
  return (
    <>
      <CommonModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type={`Account Succesfully ${status}`}
      />
      <div className="active-acc-drawer-wrapper">
        <span
          id="closeDrawer"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></span>
        <div className="activate-acc-wrap">
          <p className="sure-text"> Are you sure to {status} account </p>
          <div className="security-logo">
            <img src={SecurityLogo} alt="img" />
          </div>

          <div className="activate-drawer-bottom">
            <div className="confirm-button-wrapper">
              <div className="confirm-button-wrap">
                <>
                  <button onClick={() => confirmLock()}>Confirm</button>
                  <button
                    className="cancel-button"
                    id="closeDrawer"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivateAccDrawer;
